import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid, IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import { formatDate } from "utils/Utils";
import SubHeader from "../../components/UpdateUi/SubHeader/SubHeader";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";// ⬅️ Import config
import { userDataConfig } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
import { toCamelCase } from "utils/Utils";
import { formatRoleStringPretty } from "utils/Utils";
import { sortByString } from "utils/Utils";
import { parseAndSetFlag } from "utils/Utils";
import { textFormat } from "utils/Utils";

const User = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteUserId, setDeleteUserId] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [showTabsAsPerTheDesignationFlag, setShowTabsAsPerTheDesignationFlag] = useState(false);
  
  const {
    label,
    button,
    searchLabel,
    createUrl,
    viewUrl,
    updateUrl,
    confirmationHeader,
    confirmationMsg,
    successMsg,
    tableColumnsRole,
    tableColumnsDesignation,
  } = userDataConfig;

  const handleCreate = () => {
    navigate(createUrl);
  };
   useEffect(() => {
      getFeatureFlag();
    }, []);
    const getFeatureFlag = async () => {
      const result = await apiHandler({
        url: endpoint.FEATURE_FLAG,
      });
      setShowTabsAsPerTheDesignationFlag(parseAndSetFlag(result?.data?.showTabsAsPerTheDesignationFlag));
      const tabsAsPerTheDesignationFlag = parseAndSetFlag(result?.data?.showTabsAsPerTheDesignationFlag);
      GetData(tabsAsPerTheDesignationFlag);
    };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
   
  }, []);
  const GetData = async (tabsAsPerTheDesignationFlag) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ADMIN_USER_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate(toastAction?.error, result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
         const sortedArray = sortByString(result?.data, 'name', true);
      parseIndicatorData(result?.data, tabsAsPerTheDesignationFlag);
    }
  };

  const onSearchChange = (event) => {
    const val = event.target.value.toLowerCase();
    const filteredData = rawData.filter((row) => {
      return (
        row.name?.toLowerCase().includes(val) ||
        row.email?.toLowerCase().includes(val) ||
        formatRoleStringPretty(row.role?.toLowerCase().includes(val)) ||
        row.mobileNumber?.toLowerCase().includes(val) ||
        row.designation?.toLowerCase().includes(val) ||
        row.branchName?.toLowerCase().includes(val) ||
        row.employeeId?.toLowerCase().includes(val) ||
        formatDate(row.createdDate)?.toLowerCase().includes(val) ||
        formatDate(row.updatedDate)?.toLowerCase().includes(val)
      );
    });
    parseIndicatorData(filteredData, showTabsAsPerTheDesignationFlag);
  };
  // parseindiadata function
  const parseIndicatorData = (data, tabsAsPerTheDesignationFlag) => {
    let reportData = [];
    data.forEach((goldpay, index) => {
      let row = {
        name: goldpay.name,
        employeId:goldpay.employeeId,
        email: goldpay.email,
        mobilenumber: goldpay.mobileNumber,
        role: tabsAsPerTheDesignationFlag ? textFormat(goldpay?.designation) : formatRoleStringPretty(goldpay?.role),
        branch: goldpay?.branchName,
        active: goldpay.active ? "Active" : "Inactive",
        actions: getIcons(goldpay.id, goldpay.role),
        viewCode:goldpay.id,
      };
      reportData.push(row);
    });
    setSelectedTableData(reportData);
    setTableData(reportData);
  };

  const onClickUpdateData = (id) => {
    navigate(`${updateUrl}${id}`);
  };

  const onClickViewData = (id) => {
    navigate(`${viewUrl}${id}`);
  };

  const onClickDeleteData = (id) => {
    setConfirmationModalHeader(confirmationHeader);
    setConfirmationModalMsg(confirmationMsg);
    setDeleteUserId(id);
    setConfirmationModal(true);
  };
  const getIcons = (id, role) => (
    <>
      <IconButton
        aria-label="Edit User"
        onClick={(e) => {
          e.stopPropagation();
          onClickUpdateData(id);
        }}
      >
        <EditIcon />
      </IconButton>
      {role !== "role_head_manager" && (
        <IconButton
          aria-label="Delete User"
          onClick={(e) => {
            e.stopPropagation();
            onClickDeleteData(id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </>
  );

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteUserId("");
  };
  const handlePositiveResponse = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ADMIN_USER_DELETE + deleteUserId,
      method: "DELETE",
      authToken,
    });
    setCallInProgress(false);
    handleNegativeResponse();
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
    } else {
      toastUpdate(toastAction?.success, successMsg, true);
      GetData();
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={label}
          button1={button}
          button1click={handleCreate}
          onSearchChange={onSearchChange}
          search
          searchLabel={searchLabel}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <TableContainer component={Paper} elevation={0}>
          <ColumnGroupingTable
            columns={ showTabsAsPerTheDesignationFlag ? tableColumnsDesignation : tableColumnsRole}
            rows={selectedTableData}
            onClickViewData={onClickViewData}
            clickable
          />
        </TableContainer>
      </Grid >
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
       {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
    </Grid>
  );
};

User.propTypes = {
  classes: PropTypes.object,
};

export default User;
